export class Answer {
  constructor(value) {
    this.value = value;
  }
  static extractAnswerFromCommand(command) {
    return command === null || command === void 0 ? void 0 : command.replace('answer = ', '');
  }
  compare(pattern) {
    return pattern.exec(this.value) !== null;
  }
  getCommand() {
    return "answer = ".concat(this.value);
  }
}